import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index.js'
import {publicKeyString,privateKeyString} from './Api/common.js'
import 'lib-flexible';
import { Tab, Tabs,Search,Swipe, SwipeItem,ImagePreview,Popup,Dialog} from 'vant';//切换组件
import JSEncrypt from 'jsencrypt';
import axios from 'axios'
Vue.prototype.$getRsaCode = function(str){ // 注册方法
  let pubKey = publicKeyString
  let encryptStr = new JSEncrypt();
  encryptStr.setPublicKey(pubKey); // 设置 加密公钥
  let  data = encryptStr.encrypt(str.toString());  // 进行加密
  return data;
}
Vue.prototype.$getRsaDeCode = function(str) { // 解密
  var decrypt = new JSEncrypt()
  const pubKeyPrivate = privateKeyString// ES6 模板字符串 引用 rsa 公钥
  decrypt.setPrivateKey(pubKeyPrivate)//解密公钥
  var decryptMsg = decrypt.decrypt(str.toString()) //解密
  return decryptMsg
}
Vue.prototype.$http= axios
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Search)
Vue.use(ImagePreview)
Vue.use(Popup)
Vue.use(Dialog);
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
